<form [formGroup]="ibanForm">
  <mat-form-field
    class="custom-mapfre-grid mapfre-color-medium dark mapfre-fs-xs-r"
    appearance="outline"
    floatLabel="always"
    class="fix-prefix"
  >
    <mat-label>{{
      'BANK_DATA.PROCESS.NEW_ACCOUNT.IBAN' | translate | uppercase
    }}</mat-label>
    <input
      matInput
      [maxlength]="inputMaxLength"
      required
      type="text"
      inputmode="numeric"
      formControlName="iban"
      (paste)="onPaste($event)"
    />
    <mat-hint class="medium" *ngIf="bankName">{{
      'BANK_DATA.ENTITY' | translate: { bank: bankName }
    }}</mat-hint>
    <mat-error *ngIf="!ibanForm.get('iban')?.errors?.required">{{
      'BANK_DATA.PROCESS.NEW_ACCOUNT.ERROR.NOT_VALID' | translate
    }}</mat-error>
    <mat-error *ngIf="ibanForm.get('iban')?.errors?.required">
      {{ 'INPUT_ERROR.DATA_IS_REQUIRED' | translate }}
    </mat-error>
  </mat-form-field>
</form>
